// extracted by mini-css-extract-plugin
export var aboveInput = "_m4-0";
export var actionButton = "_m4-5";
export var actionButtonContainer = "_m4-1";
export var actionIcon = "_m4-6";
export var aiInfoContainer = "_m4-2";
export var attachmentWrapper = "_m4-7";
export var bold = "_m4-3";
export var checkIcon = "_m4-8";
export var clickingRecipientBar = "_m4-11";
export var commentThreadSwitch = "_m4-a";
export var draftImage = "_m4-b";
export var draftImageContainer = "_m4-c";
export var draftImages = "_m4-e";
export var editButton = "_m4-g";
export var editor = "_m4-f";
export var editorContainer = "_m4-y";
export var editorErrorTooltipWrapper = "_m4-9";
export var headerDivider = "_m4-h";
export var icon = "_m4-i";
export var info = "_m4-j";
export var internal = "_m4-n";
export var internalDivider = "_m4-k";
export var internalMessage = "_m4-l";
export var messageInputCard = "_m4-m";
export var messageInputForm = "_m4-o";
export var messageInputFormInternal = "_m4-p";
export var options = "_m4-q";
export var publicMessageCustomer = "_m4-s";
export var publicMessageMerchant = "_m4-r";
export var removeImageButton = "_m4-d";
export var replyButtons = "_m4-t";
export var showSignatureButton = "_m4-u";
export var spinner = "_m4-v";
export var verticalButtonDivider = "_m4-4";
export var visibilitySelector = "_m4-w";
export var warning = "_m4-x";
export var wrappingText = "_m4-z";
export var writingInternalNoteTopBorder = "_m4-10";